import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const CONTACT_ENDPOINT =
  process.env.REACT_APP_CONTACT_ENDPOINT || '';

const EMAILJS_SERVICE_ID =
  process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_4g7nq9p';
const EMAILJS_TEMPLATE_ID =
  process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_9iipf9s';
const EMAILJS_PUBLIC_KEY =
  process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '4R4g0nB1ph6FqYdON';
const CONTACT_TO_EMAIL =
  process.env.REACT_APP_CONTACT_TO_EMAIL || 'muge.tufekci@yahoo.com';

const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

const buildTemplateParams = ({ name, contact, message }) => ({
  name,
  contact,
  message,
  title: 'Yeni iletişim formu mesajı',
  time: new Date().toLocaleString('tr-TR', { timeZone: 'Europe/Istanbul' }),
  from_name: name,
  user_contact: contact,
  user_email: isValidEmail(contact) ? contact : '',
  reply_to: CONTACT_TO_EMAIL,
  to_email: CONTACT_TO_EMAIL,
});

const parseResponseBody = async (response) => {
  const contentType = response.headers.get('content-type') || '';

  if (contentType.includes('application/json')) {
    try {
      return await response.json();
    } catch {
      return {};
    }
  }

  const text = await response.text();
  return text ? { message: text } : {};
};

const sendWithNetlifyFunction = async (payload) => {
  const response = await fetch(CONTACT_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  const result = await parseResponseBody(response);

  if (!response.ok) {
    const error = new Error(result.message || 'Lütfen daha sonra tekrar deneyin.');
    error.status = response.status;
    throw error;
  }

  return result;
};

const sendWithEmailJs = async (payload) => {
  if (!EMAILJS_SERVICE_ID || !EMAILJS_TEMPLATE_ID || !EMAILJS_PUBLIC_KEY || !CONTACT_TO_EMAIL) {
    throw new Error('EmailJS ayarları eksik.');
  }

  await emailjs.send(
    EMAILJS_SERVICE_ID,
    EMAILJS_TEMPLATE_ID,
    buildTemplateParams(payload),
    { publicKey: EMAILJS_PUBLIC_KEY },
  );
};

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    contact: '',
    message: '',
  });
  const [notice, setNotice] = useState(null);

  const handleFormChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const showNotice = (message, type = 'success') => {
    setNotice({ message, type });
    window.setTimeout(() => setNotice(null), type === 'success' ? 6000 : 4000);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const { name, contact, message } = formData;

    if (!name.trim() || !contact.trim() || !message.trim()) {
      showNotice('Lütfen tüm alanları doldurun.', 'error');
      return;
    }

    const payload = {
      name: name.trim(),
      contact: contact.trim(),
      message: message.trim(),
    };

    try {
      if (CONTACT_ENDPOINT) {
        await sendWithNetlifyFunction(payload);
      } else {
        await sendWithEmailJs(payload);
      }

      showNotice('Mesajınız gönderildi!');
      setFormData({ name: '', contact: '', message: '' });
    } catch (err) {
      console.error('Email gönderilemedi:', err);
      showNotice(`Mesaj gönderilemedi: ${err.message || 'Lütfen daha sonra tekrar deneyin.'}`, 'error');
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-header">
          <h2>İletişim</h2>
        </div>
        <div className="contact-grid form-only">
          <form onSubmit={handleSubmit}>
            <label>
              Ad Soyad
              <input
                type="text"
                name="name"
                autoComplete="name"
                value={formData.name}
                onChange={handleFormChange}
              />
            </label>
            <label>
              E-posta veya Telefon
              <input
                type="text"
                name="contact"
                autoComplete="email"
                value={formData.contact}
                onChange={handleFormChange}
              />
            </label>
            <label>
              Mesajınız
              <textarea
                name="message"
                value={formData.message}
                onChange={handleFormChange}
              />
            </label>
            <button className="form-button" type="submit">
              Gönder
            </button>
          </form>
        </div>
      </div>

      {notice && (
        <div className={`snackbar ${notice.type === 'error' ? 'error' : ''}`} role="status">
          {notice.message}
        </div>
      )}
    </section>
  );
};

export default Contact;
